<script setup lang="ts" name="StepperFooterLayout"></script>

<template>
  <div class="flex justify-end gap-x-4 rounded bg-white p-6">
    <slot />
  </div>
</template>
